import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "requirements" }
const _hoisted_2 = {
  key: 0,
  class: "bool-container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "agree" }, "Please agree:", -1)
const _hoisted_4 = { class: "flex fill gap v-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "link" }, "Requirements to Participate", -1)
const _hoisted_6 = {
  key: 1,
  class: "modal"
}
const _hoisted_7 = { class: "modal-content flex column gap center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "gg-close" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.activeOrder?.requirements.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "cb flex v-center center",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.show = true), ["prevent","stop"]))
            }, [
              _createVNode(_component_checkbox, { checked: _ctx.agreed }, null, 8, ["checked"])
            ]),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.show = true), ["prevent"]))
            }, [
              _createTextVNode(" I understand the "),
              _hoisted_5,
              _createTextVNode(" and everyone in my party meets these requirements.* ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "close-button",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.show = false), ["prevent"]))
            }, _hoisted_9),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requirements, (r, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "scroll-content",
                key: 'contact-info-has-requirements-' + i
              }, [
                _createElementVNode("h5", null, _toDisplayString(r.ActivityName), 1),
                _createElementVNode("div", {
                  class: "raw",
                  innerHTML: r.Message
                }, null, 8, _hoisted_10)
              ]))
            }), 128)),
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.agree && _ctx.agree(...args)), ["prevent"])),
              class: "button"
            }, _toDisplayString(_ctx.agreed ? 'OK' : 'I agree'), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}